import React, {useState, useEffect, useRef} from 'react';
import './style.scss';


export default function Slider(props) {
    const [slides, setSlides] = useState(props.children);
    const [currSlide, setCurrSlide] = useState(1);
    const [totalViews, setTotalViews] = useState(props.totalViews ? props.totalViews : 1);
    const [slidesSeen, setSlidesSeen] = useState(new Array(props.children.length-totalViews+1).fill(false));

    const refSlides = useRef(null);

    useEffect(() => {
        selectSlide(currSlide, 0); //Move it to initial position to force an update

        window.addEventListener('resize', onWindowResize); //Updates slides offset when resizing window

        return () => {
            window.removeEventListener("resize", onWindowResize);
        }
    }, []);

    return (
        <div id={props.id} className={"slider"+(props.navbtns===false?" without-navbtns":"")+(props.dots===false?" without-dots":"")}>
            <div className="masker" style={{paddingRight:((parseInt(100/totalViews))*(totalViews-1))+"%"}}>
                <div className="slides" ref={refSlides}>
                    {slides.map((slide, i) => {
                        return (
                            <div className={`slide slide${i+1}`} key={i}>{slide}</div>
                        )
                    })}
                </div>
            </div>

            <button className={"prev-btn"+(currSlide===1?" disabled":"")} onClick={() => onPrevClick()}></button>

            <button className={"next-btn"+(currSlide>slides.length-totalViews?" disabled":"")} onClick={() => onNextClick()}></button>

            <div className="dots">
                {slides.map((slide, i) => {
                    return (
                        <span className={"dot dot"+(i+1)+" "+(currSlide===i+1?"active":"")+" "+(i<=slides.length-totalViews?"":"hide")} key={i} onClick={() => onDotClick(i+1)}></span>
                    )
                })}
            </div>
        </div>
    );

    function selectSlide(slideNo, speed) {
        let slides = refSlides.current;
        let tempSeen = [...slidesSeen];

        //Update state and position
        setCurrSlide(slideNo);

        slides.style.transition = "left "+speed+"s";
        slides.style.left = (-parseInt(window.getComputedStyle(slides).width)*(slideNo-1))+"px";

        //Update and check slides seen
        tempSeen[slideNo-1] = true;
        setSlidesSeen(tempSeen);

        if (checkSlidesSeen(tempSeen)) {
            if (props.onComplete) {
                props.onComplete();
            }
        }
    }

    function checkSlidesSeen(seen) {
        var allSeen = true;
        var i;

        for (i=0; i<seen.length; i++) {
            if (seen[i]===false) {
                allSeen = false;
            }
        }

        return allSeen;
    }

    function onPrevClick() {
        selectSlide(currSlide-1, 0.5);
    }

    function onNextClick() {
        selectSlide(currSlide+1, 0.5);
    }

    function onDotClick(dotNo) {
        selectSlide(dotNo, 0.5);
    }

    function onWindowResize() {
        selectSlide(currSlide, 0);
    }
}
